/**
 * Logos das redes da janela de compartilhar, no próprio painel (antes vinham de
 * dashboard.eminer.app). O Material Symbols não tem marcas; copiar usa `content_copy`.
 * Desenhos de 800 × 800 em uma cor só, pintados com a cor do texto.
 */
import type { ShareType } from '../../lib/shareLinks';

const PATHS: Record<Exclude<ShareType, 'clipboard'>, { d: string; evenOdd?: boolean }> = {
  whatsapp: {
    d: 'M592 459.7c-1.6-.7-59.9-29.5-70.2-33.2-4.2-1.5-8.8-3-13.6-3-7.9 0-14.5 3.9-19.6 11.6-5.8 8.7-23.5 29.3-28.9 35.4-.7.8-1.7 1.8-2.3 1.8-.5 0-9.5-3.7-12.3-4.9-62.6-27.2-110.1-92.5-116.6-103.6-.9-1.6-1-2.3-1-2.3.2-.8 2.3-2.9 3.4-4 3.2-3.1 6.6-7.3 9.9-11.3l4.7-5.6c4.8-5.6 7-10 9.5-15l1.3-2.6c6.1-12.1.9-22.3-.8-25.6-1.4-2.8-26-62.2-28.6-68.4-6.3-15.1-14.6-22.1-26.2-22.1-1.1 0 0 0-4.5.2-5.5.2-35.3 4.2-48.5 12.5-14 8.8-37.6 36.9-37.6 86.4 0 44.5 28.2 86.5 40.4 102.5.3.4.9 1.2 1.7 2.4 46.4 67.8 104.3 118 163 141.5 56.5 22.6 83.2 25.2 98.4 25.2 6.4 0 11.5-.5 16-.9l2.9-.3c19.5-1.7 62.4-23.9 72.1-51.1 7.7-21.3 9.7-44.7 4.6-53.1-3.6-5.9-9.6-8.8-17.2-12.5zM407.1 0C190.4 0 14.2 174.9 14.2 390c0 69.6 18.6 137.6 53.9 197.2L.6 786.3c-1.3 3.7-.3 7.8 2.4 10.6 2 2 4.7 3.1 7.4 3.1 1.1 0 2.1-.2 3.1-.5l207.6-66c56.8 30.4 121 46.4 186 46.4C623.7 779.9 800 605 800 390 800 174.9 623.7 0 407.1 0zm0 698.7c-61.1 0-120.4-17.7-171.3-51.1a10.56 10.56 0 0 0-5.7-1.7c-1.1 0-2.1.2-3.1.5l-104 33.1 33.6-99c1.1-3.2.5-6.7-1.5-9.5-38.8-53-59.3-115.5-59.3-181C95.8 219.8 235.4 81.3 407 81.3S718.2 219.8 718.2 390c.1 170.2-139.5 308.7-311.1 308.7z',
  },
  telegram: {
    d: 'M612.8 726c10.7 7.6 24.6 9.5 36.9 4.8s21.4-15.2 24.1-28L799.4 98.3c2-9.3-1.3-19-8.7-25.3-7.3-6.2-17.5-8-26.6-4.7l-746 278.4C6.9 350.8-.4 361.5 0 373.3s8.3 22 19.8 25.5l182.5 56.4 73.6 220.5c3.2 9.3 10.5 16.7 20.1 19.2s19.9-.1 27-6.9l103.2-97.4L612.8 726zm-367-289.3l56 184.6 12.4-116.9 339.5-306.2c3.6-3.3 4.1-8.7 1.1-12.6-3-3.8-8.4-4.7-12.5-2.1L245.8 436.7z',
    evenOdd: true,
  },
  twitter: {
    d: 'M630 38.4h122.7l-268 306.3L800 761.6H553.1L359.8 508.8 138.5 761.6H15.8L302.4 434 0 38.4h253.1l174.8 231.1L630 38.4zm-43 649.7h68L216.2 108h-72.9L587 688.1h0z',
  },
  facebook: {
    d: 'M503.8 150H600V0H473C353.2 0 300 52.7 300 153.9V250H200v150h100v400h150V400h138.1L600 250H450v-55.5c0-31.9 23-44.5 53.8-44.5z',
  },
  linkedin: {
    d: 'M27 242.9h151.9V800H27zM786.7 800V457.7c0-266.1-283.8-256.4-354.5-125.4v-89.4h-152V800h151.9V516.2c0-157.7 202.6-170.6 202.6 0V800h152zM103 0C54 0 14.3 40 14.3 89.3s39.7 89.3 88.6 89.3c49 0 88.6-40 88.6-89.3C191.6 40 151.9 0 103 0z',
  },
};

export function ShareIcon({ type }: { type: ShareType }): JSX.Element {
  if (type === 'clipboard') {
    return (
      <span className="material-symbols-rounded" aria-hidden="true">
        content_copy
      </span>
    );
  }
  const { d, evenOdd } = PATHS[type];
  return (
    <svg viewBox="0 0 800 800" fill="currentColor" aria-hidden="true">
      <path d={d} fillRule={evenOdd ? 'evenodd' : undefined} />
    </svg>
  );
}
